import {
  CITY_KEY,
  AIRPORT_KEY,
  POI_KEY,
  TRAIN_STATION_KEY,
  REGION_KEY,
  SEARCH_TYPES,
  ADDRESS_KEY,
  NEIGHBORHOOD_KEY,
  FLIGHT_KEY,
  PACKAGE_KEY,
  RECENT_SEARCHES_KEY,
} from '../constants/categoryConstants';
import { formatDatesForPicker, getRecentSearchName } from './recentSearchUtils';

const suggestionTypeMap = {
  MULTICITY: CITY_KEY,
  METROCODE: AIRPORT_KEY,
  ATTRACTION: POI_KEY,
  METROSTATION: TRAIN_STATION_KEY,
  MULTIREGION: REGION_KEY,
  CAR_LOCATION: ADDRESS_KEY,
  HIGH_LEVEL_REGION: REGION_KEY,
  COUNTRY: REGION_KEY,
  DOWNTOWN: NEIGHBORHOOD_KEY,
  TRAIN_STATION: TRAIN_STATION_KEY,
  FERRYPORT: TRAIN_STATION_KEY,
  DELIVERYCOLLECTION: ADDRESS_KEY,
  MAP_PROVIDER: ADDRESS_KEY,
  GOOGLE_PLACES: POI_KEY,
  RENTAL: ADDRESS_KEY,
  POINT_OF_INTEREST: POI_KEY,
  RECENT_SEARCHES: RECENT_SEARCHES_KEY,
};

export const getCategoriesSuggestions = (category, suggestions) => ({
  suggestions: suggestions?.filter(
    (suggestion) => (suggestionTypeMap[suggestion.type] || suggestion.type) === category.key),
  ...category,
});

export const getPrioritySuggestionsByLineOfBusiness = (lineOfBusiness, suggestions) => {
  const priortizedSuggestions = [];
  SEARCH_TYPES[lineOfBusiness]?.priority
    .forEach((suggestionType) => {
      priortizedSuggestions[
        suggestionType.key] = getCategoriesSuggestions(suggestionType, suggestions);
    });
  return priortizedSuggestions;
};

export const isFlightOrPackageLOB = (
  lineOfBusiness) => lineOfBusiness === FLIGHT_KEY || lineOfBusiness === PACKAGE_KEY;

export const getResultType = ({ lineOfBusiness, tags, isAirportLocation }) => {
  if (isFlightOrPackageLOB(lineOfBusiness)) {
    return isAirportLocation ? AIRPORT_KEY : CITY_KEY;
  }
  return tags?.toUpperCase();
};

export const getCombinedSuggestions = ({
  suggestions,
  recentSearches,
  maximumResultsToShow,
  lineOfBusiness,
}) => {
  const suggestionsToShow = suggestions?.slice(0, maximumResultsToShow);
  const combineSuggestions = [...recentSearches, ...suggestionsToShow];
  const suggestionsByLob = getPrioritySuggestionsByLineOfBusiness(
    lineOfBusiness,
    combineSuggestions
  );
  return suggestionsByLob;
};

export const getFormattedRecentSearchData = ({
  recentSearches = [],
  locale,
  connector,
}) => recentSearches.map(({
  category,
  journeyType,
  searchEndDate,
  searchStartDate,
  destinationCity,
  originCity,
  originAirportCode,
  searchStartTerm,
  searchDestinationTerm,
  destinationAirportCode,
  destinationSearchTerm,
  placeId,
  locationType,
}) => ({
  id: placeId,
  searchIdType: locationType,
  label: getRecentSearchName({
    searchStartTerm,
    startDate: null,
    endDate: null,
    locale,
    connector,
    destinationSearchTerm,
  }),
  name: getRecentSearchName({
    originCity,
    destinationCity,
    originAirportCode,
    destinationAirportCode,
    startDate: searchStartDate,
    endDate: searchEndDate,
    locale,
    connector,
    destinationSearchTerm,
  }),
  toLabel: getRecentSearchName({
    searchDestinationTerm,
    startDate: null,
    endDate: null,
    locale,
    connector,
  }),
  airportCode: originAirportCode,
  toAirportCode: destinationAirportCode,
  journeyType,
  parentId: 0,
  category,
  dates: {
    startDate: formatDatesForPicker(searchStartDate, locale),
    endDate: formatDatesForPicker(searchEndDate, locale),
  },
  type: RECENT_SEARCHES_KEY,
}));
